import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AppTranslateService } from "src/app/core/service/app-translate.service";
import { AuthService } from "src/app/core/service/auth.service";
import { ChatService } from "../../service/chat.service";

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"],
})
export class ContactUsComponent implements OnInit, AfterViewInit {
  @ViewChild("closeBtn", { static: true }) closeBtn;
  @ViewChild("myModalBtn", { static: true }) myModal;
  @ViewChild("tooltips", { static: true }) pop;

  @ViewChild("sendTxt") sendTxt: ElementRef;

  public newMessage: string;

  public user: any;

  public contactData: any;
  public replyMsg: string = "";
  public ssn: string = "";

  constructor(
    private chatService: ChatService,
    public toastr: ToastrService,
    private auth: AuthService,
    private appTranslateService: AppTranslateService
  ) {}

  ngOnInit(): void {
    this.user = this.auth.userValue;
    this.ssn = this.user.socialSecurityNumber;
    if (this.user.role != "admin") {
      this.getContact();
    }
  }

  scrollToBottom() {
    if (this.contactData.length > 0) {
      setTimeout(() => {
        var elmnt = document.getElementById("scrollMe");
        // elmnt.scrollIntoView(false);
        elmnt.scrollTop = elmnt.scrollHeight;
      }, 250);
    }
  }

  public getContact() {
    this.chatService.getChat(this.ssn).subscribe(
      (res) => {
        let data: any = res;
        this.contactData = data.enquiryChat;
        if (this.contactData) {
          this.scrollToBottom();
        }
      },
      (err) => {}
    );
  }

  ngAfterViewInit() {
    this.pop.nativeElement.click();
  }

  autoFocusFn() {
    setTimeout(() => {
      this.sendTxt.nativeElement.focus();
    }, 1000);
  }

  public sendMsg() {
    if (!this.newMessage) {
      this.toastr.error("Your message is empty!", "Error");
      return;
    }

    let sendData = {
      EnquiryId: 0,
      SocialSecurityNumber: this.user.socialSecurityNumber,
      Message: this.newMessage,
      Reply: "",
      Status: 0,
    };

    this.chatService.message(sendData).subscribe(
      (res) => {
        this.newMessage = "";
        this.getContact();
        if (this.appTranslateService.currentLang() == "sv") {
          this.toastr.success("Vi har fått din förfrågan", "Frågesändning", {
            timeOut: 2000,
          });
        } else {
          this.toastr.success("We have received your enquiry", "Query send", {
            timeOut: 2000,
          });
        }
      },
      (err) => {}
    );
  }
  public openModal() {
    this.myModal.nativeElement.click();
  }

  public closeModalFn() {
    this.newMessage = "";
  }

  public modalClose() {
    this.closeBtn.nativeElement.click(); // call modal close button
  }
}
